<template>

<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="col-lg-12">
    <b-row>
        <b-col style="text-align:center">
          <h3>Recursos / Conceptos</h3>
        </b-col>
    </b-row>

    <div class="card">
      <div class="tab-content">
        <div class="table-responsive">
          <div class="d-flex justify-content-between align-items-center mb-4 pl-4">
            <b-pagination class="p-0 m-0"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table">
            </b-pagination>
            <div class="d-flex align-items-center pl-3 mr-auto">
              <label class="p-0 m-0 pr-3 text-purple">Filtrar por tags</label>
              <vue-tags-input
                v-model="taglist"
                :autocomplete-items="tagslist"
                :add-only-from-autocomplete="true"
                @tags-changed="updatelist"
              />
            </div>
             <div class="col-md-3">
              <ResourceSearchs :routeApi="'concepts'" ref="searchcomponent"
                :perPage = "perPage"
                :newTags2 = "newTags2"
                @update="onUpdateDataResource"
                @loading="onLoading"
              />
          </div>
            <b-button @click="onNew" variant="success">
              + Añadir
            </b-button>
          </div>
          <div class="row">
            <div class="col-lg-6" v-for="concept in resources" v-bind:key="concept.ID">
              <div class="row image-card">
                <b-col>
                  <b-row class="mb-4">
                    <div class="file-name col-lg-12 mt-2 d-inline-flex align-items-center justify-content-between">
                        <div class="text-muted col-md-10">{{concept.NOMBRE}}</div>
                        <div class="col-md-2">
                          <button type="button"
                          class="btn btn-icon btn-icon-mini btn-round btn-info"
                          @click="editConcept(concept)">
                              <i class="zmdi zmdi-edit"></i>
                          </button>
                          <button type="button"
                          class="btn btn-icon btn-icon-mini btn-round btn-danger"
                          @click="deleteConcept(concept.ID)">
                              <i class="fa fa-trash"></i>
                          </button>
                        </div>
                    </div>
                  </b-row>
                  <b-row>
                    <div class="col-lg-12">
                        <div class="d-flex flex-row justify-content-center align-items-center" style="min-height:200px">
                          <div class="hover">
                              <a :href="getTranslation(concept.FICHERO)" target="_blank" title="Abrir a pantalla completa">
                                <span>{{languageGlobal + ' '}}</span><i class="zmdi zmdi-loupe"></i>
                              </a>
                          </div>
                          <!--<img onerror="this.onerror=null;this.src='./notfound.png';"-->
                          <img :src="getTranslation(concept.FICHERO)"
                          alt="img" class="img-fluid" width="auto" style="max-height:200px;">
                        </div>
                        <p class="mb-3 mt-3">{{getTranslation(concept.TEXTO)}}</p>
                    </div>
                  </b-row>
                </b-col>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Info modal -->
    <b-modal :id="infoModal.id" size="xl" :title="infoModal.title" hide-footer>
       <div class="modal-body">
              <div class="d-block">
                <div>
                  <label for="">Nombre del concepto</label>
                  <b-form-input
                    id="textarea"
                    v-model="selectedItem.NOMBRE"
                    placeholder="Nombre del concepto"
                    :state="($v.selectedItem.NOMBRE.$dirty && submitted)?
                    !$v.selectedItem.NOMBRE.$error : null"
                    aria-describedby="nombre-feedback"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback id="nombre-feedback">
                    Este campo es requerido.
                  </b-form-invalid-feedback>
                  <hr/>
                  <b-row>
                    <b-col style="text-align:center" class="d-flex justify-content-center align-items-center">
                      <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="selectedItem.IMAGENES_ID !== null && selectedItem.IMAGENES_ID !== 0"
                        @click="openResourceWithParam('images', selectedItem.IMAGENES_ID)"/>
                      Recursos Imágenes: <searchimages idModal="mdlSearchImages" class="ml-2"
                            v-on:selected="onSelectedImage($event)">
                      </searchimages>
                      <b-form-input
                        id="imagesid"
                        v-model="selectedItem.IMAGENES_ID"
                        :state="($v.selectedItem.IMAGENES_ID.$dirty && submitted) ?
                          !$v.selectedItem.IMAGENES_ID.$invalid : null"
                        aria-describedby="images_id-feedback"
                        style="display:none"
                      >
                      </b-form-input>
                      <b-form-invalid-feedback id="images_id-feedback" style="text-align:center">
                        Debe selecciona un recurso de Imagen existente
                      </b-form-invalid-feedback>
                    </b-col>
                  </b-row>
                  <div class="row" style="margin-bottom:20px">
                      <div class="file-name col-lg-12">
                          <p class="m-b-5 text-muted text-center">{{selectedItem.NOMBRE_IMAGEN}}</p>
                      </div>
                      <div class="col-lg-12">
                        <div class="image text-center">
                            <img :src="getTranslation(selectedItem.FICHERO)" alt="img"
                            style="width:110px;height:110px" class="img-fluid">
                        </div>
                      </div>
                  </div>
                  <hr/>
                  <b-row>
                    <b-col style="text-align:center" class="d-flex justify-content-center align-items-center">
                      <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="selectedItem.TEXTOS_ID_TITULO !== null && selectedItem.TEXTOS_ID_TITULO !== 0"
                        @click="openResourceWithParam('texts', selectedItem.TEXTOS_ID_TITULO)"/>
                      Recursos Textos: <searchtexts idModal="mdlSearchTexts" class="ml-2"
                        v-on:selected="onSelected($event)">
                      </searchtexts>
                    </b-col>
                  </b-row>
                  <label for="">Texto</label>
                   <b-form-textarea
                    id="textarea"
                    v-bind:value="getTranslation(selectedItem.TEXTOS)"
                    placeholder="Texto Español..."
                    rows="3"
                    max-rows="6"
                    :readonly=true
                  >
                   </b-form-textarea>
                </div>
                <div>
                  <b-form-input
                    id="textosid"
                    v-model="selectedItem.TEXTOS_ID_TITULO"
                    :state="($v.selectedItem.TEXTOS_ID_TITULO.$dirty && submitted) ?
                      !$v.selectedItem.TEXTOS_ID_TITULO.$invalid : null"
                    aria-describedby="textos_id-feedback"
                    style="display:none"
                  >
                  </b-form-input>
                   <b-form-invalid-feedback id="textos_id-feedback" style="text-align:center">
                    Debe buscar un recurso de Texto existente
                  </b-form-invalid-feedback>
               </div>
              </div>
              <label for="Tag">
                       <br>
                          Etiquetas</label>
                            <div>
                            <vue-tags-input
                              v-model="tag"
                              :tags="tags"
                              :autocomplete-items="autocompleteItems"
                              @tags-changed="update"
                            />
                          </div>
              <div class="modal-footer">
                <button type="button" @click="save"
                class="btn btn-info btn-round waves-effect">
                  Guardar</button>
                <b-button class="btn btn-default btn-round waves-effect" block
                @click="$bvModal.hide('info-modal')">Cerrar</b-button>
            </div>
        </div>
    </b-modal>
</div>
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input';
import { required } from 'vuelidate/lib/validators';
import searchtexts from '../texts/SearchTexts.vue';
import searchimages from '../images/SearchImages.vue';
import ResourceSearchs from '../../../components/panel/ResourceSearchs.vue';
import searchMixin from '../../../mixins/search';
import translationMixin from '../../../mixins/translation';

export default {
  components: {
    searchtexts, searchimages, VueTagsInput, ResourceSearchs,
  },
  name: 'gridConcepts',
  mixins: [searchMixin, translationMixin],
  data() {
    return {
      mounted: null,
      perPage: 20,
      rows: 0,
      submitted: false,
      currentPage: 1,
      resources: [],
      selectedItem: {
        ID: null,
        NOMBRE: null,
        TEXTOS_ID_TITULO: null,
        TEXTOS: [],
        IMAGENES_ID: null,
        FICHERO: [],
      },
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      tag: '',
      taglist: '',
      tags: [],
      tagslist: [],
      newTags: [],
      newTags2: [],
      autocompleteItems: [],
    };
  },
  validations: {
    selectedItem: {
      NOMBRE: {
        required,
      },
      TEXTOS_ID_TITULO: {
        required,
      },
      IMAGENES_ID: {
        required,
      },
    },
  },
  methods: {
    onSelected(itemSelected) {
      this.selectedItem.TEXTOS = itemSelected.TEXTOS;
      this.selectedItem.TEXTOS_ID_TITULO = itemSelected.ID;
      this.$root.$emit('bv::hide::modal', 'mdlSearchTexts');
    },
    onSelectedImage(itemSelected) {
      this.selectedItem.FICHERO = itemSelected.FICHERO;
      this.selectedItem.IMAGENES_ID = itemSelected.ID;
      this.selectedItem.NOMBRE_IMAGEN = itemSelected.NOMBRE;
      this.$root.$emit('bv::hide::modal', 'mdlSearchImages');
      this.$v.selectedItem.$touch();
    },
    onNew() {
      this.submitted = false;
      this.selectedItem.ID = null;
      this.limpiar();
      this.infoModal.title = 'Crear conceptos';
      this.tag = '';
      this.tags = [];
      this.$root.$emit('bv::show::modal', this.infoModal.id);
    },
    limpiar() {
      this.selectedItem.ID = null;
      this.selectedItem.NOMBRE = null;
      this.selectedItem.TEXTOS_ID_TITULO = null;
      this.selectedItem.TEXTOS = [];
      this.selectedItem.FICHERO = [];
      this.selectedItem.IMAGENES_ID = null;
      this.selectedItem.NOMBRE_IMAGEN = null;
      this.tag = '';
      this.tags = [];
    },
    remove(index) {
      console.log('removiendo');
      console.log(index);
    },
    async deleteConcept(idconcept) {
      const confirmation = await this.$bvModal.msgBoxConfirm('Esta a punto de eliminar un registro ¿Esta seguro?');
      if (confirmation) {
        /** Elimino los tags asociados */
        const url = `Tagsconceptos/deleteTags/${idconcept}`;
        this.axios.get(url);

        this.loading = true;
        const response = await this.axios.post('concepts/delete', { ID: idconcept });
        if (response.data.status === 'success') {
          this.loading = false;
          this.$toasted.show('Se elimino el registro seleccionado.', { theme: 'outline', type: 'success', duration: 5000 });
          this.getPostData();
        } else {
          this.loading = false;
          this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
        }
      }
    },
    editConcept(conceptObj) {
      this.selectedItem.ID = conceptObj.ID;
      this.selectedItem.NOMBRE = conceptObj.NOMBRE;
      this.selectedItem.TEXTOS_ID_TITULO = conceptObj.TEXTOS_ID_TITULO;
      this.selectedItem.TEXTOS = conceptObj.TEXTO;
      this.selectedItem.IMAGENES_ID = conceptObj.IMAGENES_ID;
      this.selectedItem.NOMBRE_IMAGEN = conceptObj.NOMBRE_IMAGEN;
      this.selectedItem.FICHERO = conceptObj.FICHERO;
      this.infoModal.title = 'Editar concepto';
      this.getExistingTags(conceptObj.ID);
      this.$root.$emit('bv::show::modal', this.infoModal.id);
    },
    async save() {
      this.submitted = true;
      this.$v.selectedItem.$touch();
      if (this.$v.selectedItem.$anyError) {
        return;
      }
      this.loading = true;
      const textData = {
        ID: this.selectedItem.ID || -1,
        NOMBRE: this.selectedItem.NOMBRE,
        TEXTOS_ID_TITULO: this.selectedItem.TEXTOS_ID_TITULO,
        IMAGENES_ID: this.selectedItem.IMAGENES_ID,
      };
      try {
        const response = await this.axios.post('concepts/store', textData);
        if (response.data.status === 'success') {
          // Solo si esta creando agrego el evento
          if (this.selectedItem.ID === -1 || this.selectedItem.ID === null) {
            const bc = new BroadcastChannel('new_resource_concept');
            bc.postMessage(response.data.textDynamic);
          }

          const url = `Tagsconceptos/deleteTags/${response.data.id}`;
          const url2 = 'Tagsconceptos/saveTag';

          this.axios.get(url);
          this.newTags.forEach((a) => {
            this.axios.get(`Tags/findTagByName/${a.text}`,
              { name: a.text }).then((resp) => {
              if (resp.data.status === 'success') {
                this.axios.post(url2, { id: resp.data.id, idconcepto: response.data.id });
              } else {
                this.axios.post(url2, { id: a.key, idconcepto: response.data.id });
              }
            });
          });

          this.$toasted.show('Los datos se guardaron satisfactoriamente.', { theme: 'outline', type: 'success', duration: 5000 });
          this.$root.$emit('bv::hide::modal', this.infoModal.id);
          this.limpiar();

          // Auto close if coming from a create event
          if (this.bAutoClose) {
            window.open('', '_self').close();
          }

          this.getPostData();
        } else {
          this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
        }
        this.loading = false;
      } catch (e) {
        const resp = e;
        if (!resp.body.Ok) {
          this.$toasted.show(resp.body.Message, { theme: 'outline', type: 'error', duration: 5000 });
        }
        this.loading = false;
      }
    },
    async getPostData() {
      this.loading = true;
      try {
        const response = await this.axios.get('concepts', {
          params: {
            currentPage: this.currentPage,
            size: this.perPage,
            newTags: this.newTags2,
            resourcetosearch: this.$refs.searchcomponent.resoursetosearch,
          },
        });
        this.rows = response.data.rows;
        this.resources = Object.keys(response.data.results).map(k => response.data.results[k]);
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    initItems() {
      const url = 'Tags';
      const datos = [];

      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ text: a.NOMBRE, key: a.ID });
        });
        this.autocompleteItems = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    listTags() {
      const url = 'Tags';
      const datos = [];
      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ key: a.ID, text: a.NOMBRE });
        });
        this.tagslist = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    update(newTags) {
      this.tags = newTags;
      this.newTags = newTags;
    },
    updatelist(newTags) {
      this.newTags2 = newTags;
      this.getPostData();
    },
    async getExistingTags(idconcepto) {
      const url = `Tagsconceptos/findByconcepto/${idconcepto}`;
      const datos = [];
      this.loading = true;

      try {
        this.axios.get(url).then((res) => {
          res.data.forEach((a) => {
            datos.push({ text: a.NOMBRE, key: a.ID });
          });
          this.tags = datos;
        })
          .catch((error) => {
            console.error(error);
          });
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
  },
  async mounted() {
    await this.getPostData();
    this.initItems();
    this.listTags();

    // Open create modal automatically
    const self = this;
    const bc = new BroadcastChannel('new_resource_concept_open');
    bc.onmessage = () => {
      self.bAutoClose = true;
      self.onNew();
    };

    // Get params Id for edit
    if (this.$route.params.id != null) {
      this.loading = true;
      const response = await this.axios.get('concepts/getconcept', {
        params: {
          id: this.$route.params.id,
        },
      });
      const conceptObj = response.data;
      this.loading = false;
      this.editConcept(conceptObj);
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.getPostData().catch((error) => {
          console.error(error);
        });
      },
    },
  },
};
</script>

<style>
  .tdActionClass{
    width: 180px;
    text-align: center;
  }
</style>
